import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { auth } = stateEnum

const initialState = {
  isAuthenticated: false,
  currentUser: {},
  token: null,
  refreshToken: null,
}
 
const authSlice = createSlice({
  name: auth,
  initialState,
  reducers: {
    setLogout: (state) => {
      state.refreshToken = null
      state.token = null
      state.isAuthenticated = false
      state.currentUser = {}
    },
    resetToken: (state, action) => {
      state.refreshToken = action.payload.data.refreshToken
      state.token = action.payload.data.token
      state.token = null
      state.isAuthenticated = false
    },
    setLogin: (state, action) => {

      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken
      state.isAuthenticated = true
      state.currentUser = action.payload.user
    },
  }, 
})

export const { setLogout, resetToken, setLogin } = authSlice.actions

export default authSlice.reducer
